<template>
  <div class="loader">Loading...</div>
</template>

<script lang="ts">
export default {
  name: 'Loader'
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.loader,
.loader:after {
  border-radius: 50%;
  width: 32px;
  height: 32px;
}
.loader {
  margin: 80px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 5px solid #e5f7f6;
  border-right: 5px solid #e5f7f6;
  border-bottom: 5px solid #e5f7f6;
  border-left: 5px solid var.$color-main;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
